import React from 'react';

const Portfolio = () => {
    return (
        <div>
            <h2>Coming Soon</h2>
        </div>
    );
};

export default Portfolio;